module.exports = __webpack_public_path__ + "img/horizontal_6_5_8004.44e6d1d8.png";